export function isIOSDevice(platform = typeof navigator === 'undefined' ? {} : navigator) {
  return /iPhone|iPad|iPod/.test(platform.userAgent ?? '')
    || ((platform.platform === 'MacIntel' || /Macintosh/.test(platform.userAgent ?? '')) && platform.maxTouchPoints > 1);
}

// Avoid starting every full-resolution image decode at once on iOS.
export function createDecodeScheduler(limit = 2) {
  let active = 0;
  const waiting = [];
  function drain() {
    while (active < limit && waiting.length) {
      const {work, resolve, reject} = waiting.shift();
      active++;
      Promise.resolve().then(work).then(resolve, reject).finally(() => { active--; drain(); });
    }
  }
  return work => new Promise((resolve, reject) => { waiting.push({work, resolve, reject}); drain(); });
}
